import { createSlice } from '@reduxjs/toolkit';
import { MOS } from './types';

export const mosSlice = createSlice({
  name: MOS,
  initialState: {},
  reducers: {
    requestMosResyncPlaylist: () => {},
  },
});

const actions = mosSlice.actions;
const mosReducer = mosSlice.reducer;

export { actions, mosReducer };
